import { render } from "./commodity.vue?vue&type=template&id=3007c9c2&scoped=true"
import script from "./commodity.vue?vue&type=script&lang=js"
export * from "./commodity.vue?vue&type=script&lang=js"

import "./commodity.vue?vue&type=style&index=0&id=3007c9c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3007c9c2"]])

export default __exports__